import { useEffect, useState } from "react";

export default function Home() {
  const [h, setH] = useState(null);
  const API = import.meta.env.VITE_API_BASE_URL;

  useEffect(() => {
    fetch(`${API}/v1/health`, { credentials:"include" })
      .then(r=>r.json()).then(setH).catch(()=>setH({ok:false}));
  }, []);

  return (
    <div style={{ padding: 16 }}>
      <h1>Sterling Ops Portal</h1>
      {!h ? <p>Loading…</p> : (
        <>
          <p><strong>Worker:</strong> {h.ok ? "UP ✅" : "DOWN ❌"} • <strong>Time:</strong> {h.time}</p>
          <p><strong>Counts:</strong> users {h.counts?.users ?? 0}, events {h.counts?.events ?? 0}, rsvps {h.counts?.rsvps ?? 0}</p>
          <p><strong>Last backup:</strong> {h.last_backup || "—"}</p>
          <p style={{fontSize:12,opacity:.7}}>Use the tabs above. Profile → login; Admin & DEV tabs appear for admins/devs.</p>
        </>
      )}
    </div>
  );
}
